<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>复贷报表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <el-tabs type="border-card" style="width: 100%;">
                    <el-tab-pane label="用户">
                        <el-tabs type="border-card" style="width: 100%;">
                            <div class="listright" v-loading="loading">
                                <div class="searchleft">
                                    <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                        <el-form-item label="客户类型">
                                            <el-select v-model="searchform.type" placeholder="请选择" style="width:150px">
                                                <el-option label="全部" value="0"></el-option>
                                                <el-option label="新客" value="1"></el-option>
                                                <el-option label="新转老" value="2"></el-option>
                                                <el-option label="老转老" value="3"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item :label="$t('channel')">
                                            <el-select size="small" v-model="searchform.blurry" multiple :placeholder="$t('qxz')" style="width:150px">
                                                <el-option v-for="item in typeList"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="App">
                                            <el-select size="small" v-model="searchform.app" multiple @change="onAppChange" :placeholder="$t('qxz')" style="width:150px">
                                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                                <el-option v-for="item in appChannelList"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="子产品">
                                            <el-select size="small" v-model="searchform.platform" :disabled="subProductChannelList.length === 0" :placeholder="$t('qxz')" style="width:150px">
                                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                                <el-option
                                                    v-for="item in subProductChannelList"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="结清次数等于">
                                            <el-select v-model="searchform.number" placeholder="请选择" style="width:150px">
                                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                                <el-option label="0" value="0"></el-option>
                                                <el-option label="1" value="1"></el-option>
                                                <el-option label="2" value="2"></el-option>
                                                <el-option label="3+" value="3"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="结清日时间">
                                            <el-date-picker
                                                v-model="value1"
                                                type="daterange"
                                                size="small"
                                                @change="checkdata"
                                                range-separator="至"
                                                value-format="yyyy-MM-dd"
                                                start-placeholder="开始时间"
                                                end-placeholder="结束时间">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <div class="top"></div>
                                <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                    <el-table-column prop="settlement_day" label="结清日"></el-table-column>
                                    <el-table-column prop="settlement_count" label="结清数"></el-table-column>
                                    <el-table-column prop="current_repeat_application_user" label="当前复申"></el-table-column>
                                    <el-table-column prop="current_repeat_loan_user" label="当前复贷"></el-table-column>
                                    <el-table-column prop="current_repeat_application_rate" label="当前复申率"></el-table-column>
                                    <el-table-column prop="current_repeat_loan_rate" label="当前复贷率"></el-table-column>
                                    <el-table-column prop="re_review_approval_rate" label="复申通过率"></el-table-column>
                                    <el-table-column prop="1_day_repeat_application_rate" label="1天复申率"></el-table-column>
                                    <el-table-column prop="3_day_repeat_application_rate" label="3天复申率"></el-table-column>
                                    <el-table-column prop="7_day_repeat_application_rate" label="7天复申率"></el-table-column>
                                    <el-table-column prop="15_day_repeat_application_rate" label="15天复申率"></el-table-column>
                                    <el-table-column prop="30_day_repeat_application_rate" label="30天复申率"></el-table-column>
                                </el-table>
                            </div>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane label="订单">
                        <el-tabs type="border-card" style="width: 100%;">
                            <div class="listright" v-loading="loading1">
                                <div class="searchleft">
                                    <el-form :inline="true" :model="searchform1" class="demo-form-inline" @submit.native.prevent >
                                        <el-form-item label="客户类型">
                                            <el-select v-model="searchform1.type" placeholder="请选择" style="width:150px">
                                                <el-option label="全部" value="0"></el-option>
                                                <el-option label="新客" value="1"></el-option>
                                                <el-option label="新转老" value="2"></el-option>
                                                <el-option label="老转老" value="3"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item :label="$t('channel')">
                                            <el-select size="small" v-model="searchform1.blurry" multiple :placeholder="$t('qxz')" style="width:150px">
                                                <el-option v-for="item in typeList"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="App">
                                            <el-select size="small" v-model="searchform1.app" multiple @change="onAppChange" :placeholder="$t('qxz')" style="width:150px">
                                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                                <el-option v-for="item in appChannelList"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="子产品">
                                            <el-select size="small" v-model="searchform1.platform" :disabled="subProductChannelList.length === 0" :placeholder="$t('qxz')" style="width:150px">
                                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                                <el-option
                                                    v-for="item in subProductChannelList"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        </el-form-item>
                                        <el-form-item label="结清次数等于">
                                            <el-select v-model="searchform1.number" placeholder="请选择" style="width:150px">
                                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                                <el-option label="0" value="0"></el-option>
                                                <el-option label="1" value="1"></el-option>
                                                <el-option label="2" value="2"></el-option>
                                                <el-option label="3+" value="3"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="结清日时间">
                                            <el-date-picker
                                                v-model="value1"
                                                type="daterange"
                                                size="small"
                                                @change="checkdata"
                                                range-separator="至"
                                                value-format="yyyy-MM-dd"
                                                start-placeholder="开始时间"
                                                end-placeholder="结束时间">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button size="small" type="primary" @click="onSubmit1">{{$t('query')}}</el-button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <div class="top"></div>
                                <el-table :data="list1" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                    <el-table-column prop="settlement_day" label="结清日(day)"></el-table-column>
                                    <el-table-column prop="settlement_count" label="结清数"></el-table-column>
                                    <el-table-column prop="current_repeat_application_user" label="当前复申"></el-table-column>
                                    <el-table-column prop="current_repeat_loan_user" label="当前复贷"></el-table-column>
                                    <el-table-column prop="current_repeat_application_rate" label="当前复申率"></el-table-column>
                                    <el-table-column prop="current_repeat_loan_rate" label="当前复贷率"></el-table-column>
                                    <el-table-column prop="re_review_approval_rate" label="复申通过率"></el-table-column>
                                    <el-table-column prop="1_day_repeat_application_rate" label="1天复申率"></el-table-column>
                                    <el-table-column prop="3_day_repeat_application_rate" label="3天复申率"></el-table-column>
                                    <el-table-column prop="7_day_repeat_application_rate" label="7天复申率"></el-table-column>
                                    <el-table-column prop="15_day_repeat_application_rate" label="15天复申率"></el-table-column>
                                    <el-table-column prop="30_day_repeat_application_rate" label="30天复申率"></el-table-column>
                                </el-table>
                            </div>
                        </el-tabs>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    userName: null,
                    email: null,
                    channel: null,
                },
                searchform: {
                    blurry: null,
                    number: "",
                    day: "",
                    type1: "",
                    app:"",
                    platform:"",
                },
                searchform1: {
                    blurry: null,
                    number: "",
                    day: "",
                    type1: "",
                    app:"",
                    platform:"",
                },
                loading: false,
                loading1:false,
                showadd: false,
                phone:null,
                list: [],
                list1: [],
                value1:null,
                typeList: [],
                appChannelList: [],
                subProductChannelList: [],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getTypeList()
            this.getList(0)
            this.getList(1)
            this.getAppChannel()
        },
        computed: {
            filteredPlatforms() {
                if (!this.searchform.app) return []; // 默认空
                return this.platformOptions.filter(item => item.app === this.searchform.app);
            }
        },
        methods: {
            onAppChange(val) {
                this.searchform.platform=null
                if (val === null) {
                    this.subProductChannelList=[]
                } else {
                    this.getSubProductChannel();
                }
            },
            getNowTime() {
                const now = Date.now();
                const startDate = new Date(now - 7 * 86400000); // 7天前
                const endDate = new Date(now + 1 * 86400000);   // 1天后

                // 本地时间格式化函数
                const formatLocalDate = (date) => {
                    return [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0')
                    ].join('-');
                };
                return [formatLocalDate(startDate), formatLocalDate(endDate)];
            },
            getTypeList() {
                _api.get(apiurl.typeList, {
                }).then(res => {
                    this.typeList = res.data
                })
            },
            getAppChannel() {
                _api.get(apiurl.appChannel, {
                }).then(res => {
                    this.appChannelList = res.data
                })
            },
            getSubProductChannel() {
                _api.get(apiurl.subProductChannel, {
                    app: this.searchform.app
                }).then(res => {
                    this.subProductChannelList = res.data
                })
            },
            getList(iden) {
                if (iden == 0) {
                    this.loading = true
                } else {
                    this.loading1 = true
                }
                if (this.value1 == null) {
                    this.$message.error(this.$t('tel87'))
                    return
                }
                const type = null; 
                if (iden == 0 && this.searchform.blurry != null) {
                    this.type = this.searchform.blurry.join(",")
                }
                if (iden == 1 && this.searchform1.blurry != null) {
                    this.type = this.searchform1.blurry.join(",")
                }
                const customerType = null;
                const app = null; 
                const platform = null; 
                const number = null; 
                if (iden == 0) {
                    this.customerType = this.searchform.type,
                    this.app = this.searchform.app,
                    this.platform = this.searchform.platform,
                    this.number = this.searchform.number
                } else {
                    this.customerType = this.searchform1.type,
                    this.app = this.searchform1.app,
                    this.platform = this.searchform1.platform,
                    this.number = this.searchform1.number
                }
                _api.get(apiurl.relending, {
                    type: this.type,
                    createTime: this.value1,
                    iden: iden,
                    customerType: this.customerType,
                    app: this.app,
                    platform: this.platform,
                    number: this.number,
                }).then(res => {
                    if (iden == 0) {
                        this.loading = false
                        this.list = res.data
                    } else {
                        this.loading1 = false
                        this.list1 = res.data
                    }
                })
            },
            onSubmit() {
                this.getList(0)
            },
            onSubmit1() {
                this.getList(1)
            }
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>